import clsx from 'clsx';
import React from 'react';

import { ArrowDownIcon } from '../../Icons';
import styles from './Programs.module.scss';

import { ProgramsProps } from './Programs.type';

export const Programs: React.FC<ProgramsProps> = (props) => {
    const { data, activeKey, toggleList } = props;

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Программные модули</h1>
            <div className={styles.content}>
                {data.map((item, key) => (
                    <div
                        key={key}
                        className={clsx(
                            styles.item,
                            activeKey === key && styles.active
                        )}
                    >
                        <div
                            className={styles.itemTitle}
                            onClick={() => toggleList(key)}
                        >
                            <ArrowDownIcon className={styles.icon} />
                            {item.title}
                        </div>
                        {activeKey === key && (
                            <div className={styles.itemHidden}>
                                {item.lists.map((list, listKey) => (
                                    <div
                                        key={listKey}
                                        className={styles.itemRowBlock}
                                    >
                                        <div className={styles.itemRowTitle}>
                                            {list.title}
                                        </div>
                                        <ul>
                                            {list.rows.map((row, rowKey) => (
                                                <li
                                                    key={rowKey}
                                                    className={styles.itemRow}
                                                >
                                                    {row}
                                                </li>
                                            ))}
                                        </ul>
                                        {activeKey === 2 && listKey === 0 && (
                                            <p className={styles.itemRowTitle}>
                                                Это, прежде всего, относится к
                                                взаимодействию с{' '}
                                                <a
                                                    className={styles.itemLink}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                    href="https://zakupki.gov.ru/epz/main/public/home.html"
                                                >
                                                    «Главным порталом закупок»
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                ))}
                                {item.links.length > 0 && (
                                    <div className={styles.itemLinks}>
                                        {item.links.map((link, linkKey) => (
                                            <a
                                                href={link.url}
                                                download
                                                key={linkKey}
                                                className={styles.itemLink}
                                            >
                                                {link.name
                                                    ? link.name
                                                    : link.url}
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
